/*
 * @Author: 范朝阳
 * @Date: 2020-12-18 16:47:44
 * @LastEditTime: 2020-12-21 17:05:21
 * @LastEditors: 范朝阳
 * @Description: 修改描述
 * @FilePath: /trunk/src/components/index.js
 */
import UmPrint from '@/components/UmPrint'

import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import UmMap from './UmMap'
import UmSelect from './UmSelect'

import BackToTop from './BackToTop' // 返回顶部
import Pagination from './Pagination' // 分页

import UmBusOrgan from './UmBusOrgan'
import UmBusRole from './UmBusRole'
import UmUploadImg from './UmUploadImg'
import ElSelectTree from './ElSelectTree'
import UmBusBuilding from './UmBusBuilding'

import UmUpload from './UmUpload'
import UmSteps from './UmSteps'
import UmForm from './UmForm/index.vue'

import ExportFile from './UmExport/index.js'
import ImportFile from './UmImport/index.js'
import UmBusUser from './UmBusUser/index.js'
import UmBusProject from './UmBusProject'
import UmBreadCrumb from './UmBreadCrumb'

import UmBusRoleApi from './UmBusRole/api.js'

import UmFrom from './UmForm/index.js'

const Components = [
  ElImageViewer,
  UmMap,
  UmSelect,
  BackToTop,
  Pagination,
  UmBusOrgan,
  UmBusRole,
  UmUploadImg,
  ElSelectTree,
  UmBusBuilding,
  UmUpload,
  UmSteps,
  UmForm,
  UmBusProject,
  UmBreadCrumb
]

// 定义 install 方法
const install = function(Vue) {
  if (install.installed) return
  install.installed = true

  // 遍历并注册全局组件
  Components.forEach(component => {
    Vue.component(component.name, component)
  })
  // APi 方法注册
  Vue.use(UmBusRoleApi)
  Vue.use(UmFrom)
  Vue.use(ExportFile)
  Vue.use(ImportFile)
  Vue.use(UmBusUser)
  Vue.use(UmPrint)
}
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
export default {
  install,
  // 组件列表
  ...Components
}
